<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form :rules="rules" ref="form" label-width="150px" :model="dioForm">
            <el-form-item :label="$t('param.name')" prop="name">
                <el-input v-model.trim="dioForm.name" style="width: 250px"
                    :placeholder="$t('param.param_content_name')" />
            </el-form-item>
            <el-form-item :label="$t('param.code')" prop="code">
                <el-input v-model.trim="dioForm.code" style="width: 250px" :placeholder="$t('param.param_content_code')"
                    v-if="optareStatus === 'add'" />
                <span v-else>{{ dioForm.code }}</span>
            </el-form-item>
            <el-form-item :label="$t('param.desc')" prop="desc">
                <el-input v-model.trim="dioForm.desc" type="textarea" style="width: 250px" maxlength="250"
                    show-word-limit :autosize="{ minRows: 4, maxRows: 8 }"
                    :placeholder="$t('param.param_contetn_value')" />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_apply') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { paramContentAdd, paramContentUpdate } from '@/api/modules/params.js'
export default {
    props: {
        formRow: {
            type: Object,
            default: () => { }
        },
        isShow: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        optareStatus: {
            type: String,
            default: ""
        },
        typeParam: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        },
        rules() {
            return {
                name: [{ required: true, message: this.$t('validate.param_name_required'), trigger: 'blur' },
                {
                    max: 10,
                    trigger: 'blur',
                    message: this.$t('validate.len_10')
                }
                ],
                code: [{ required: true, message: this.$t('validate.param_code_required'), trigger: 'blur' },
                {
                    max: 30,
                    trigger: 'blur',
                    message: this.$t('validate.len_30')
                },
                {
                    validator: this.$fromRules.FormValidate.Form().ParamCode,
                    trigger: 'blur',
                },
                ],
            }
        }
    },
    watch: {
        formRow(newVal) {
            this.dioForm = { ...newVal }
        }
    },
    data() {
        return {
            dioForm: {
                name: "",
                code: "",
                desc: ""
            },
        }
    },
    methods: {
        clearValidate() {
            this.dioForm = {
                name: "",
                code: "",
                desc: ""
            }
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate()
            }
            catch (error) {
                return false
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return
            let httpUrl = paramContentAdd
            if (this.optareStatus === 'edit') {
                httpUrl = paramContentUpdate
            }
            httpUrl(this.dioForm).then(({ state, result }) => {
                if (result === 200) {
                    this.$message.success(this.$t('param.code_200'));
                    this.$parent.listQuery.iDisplayStart = 0;
                    this.$parent.listQuery.iDisplayLength = 50;
                    this.$parent.letContent = [];
                    this.$parent.getList();
                    this.isShowDialog = false
                } else if (result === 400) {
                    this.$message.error(this.$t('param.code_400'))
                }
                else if (result === 407) {
                    this.$message.error(this.$t('param.code_407'))
                } else if (result === 408) {
                    this.$message.error(this.$t('param.code_408'))
                } else {
                    this.$message.error(this.$t('param.code_other'))
                }
            })
        },
    }
}
</script>

<style scoped>

</style>